export function visibilityAdaptor({ item }) {
  return {
    visibility: item?.visibility,
  }
}
